// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2wazy","content":"LayoutSettings_content__Ttyl9"};